import { bignumber } from 'mathjs'

// 仅用于展示，计算和提交时仍使用原始汇率。
export function formatExchangeRate(value) {
  if ((typeof value !== 'number' && typeof value !== 'string') ||
      String(value).trim() === '' || !Number.isFinite(Number(value))) {
    return '-'
  }

  const rate = bignumber(value)
  return rate.toFixed(4, rate.constructor.ROUND_HALF_UP)
}
